// The PIR Library is a single SharePoint location shared by every environment,
// so it is a constant rather than per-environment config (see SLACK_WORKSPACE_HOST).
export const PIR_LIBRARY_URL = 'https://coxautoinc.sharepoint.com/sites/core/Post%20Incident%20Reviews';
